function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 283.5 283.5"
}, props), /*#__PURE__*/React.createElement("g", {
  id: "Smart_plug"
}, /*#__PURE__*/React.createElement("path", {
  d: "M141.7 85.2c-54.8 0-99.2 30.8-99.2 99.1s44.4 99.1 99.2 99.1c54.8 0 99.2-30.8 99.2-99.1s-44.4-99.1-99.2-99.1zm51.2 153.3c-15.2 13.7-36.2 16.6-51.1 16.6-14.9 0-35.9-2.9-51.1-16.6C77.6 226.7 71 208.4 71 184.4c0-24.1 6.6-42.3 19.7-54.1 15.2-13.7 36.2-16.6 51.1-16.6 14.9 0 35.9 2.9 51.1 16.6 13.1 11.8 19.7 30.1 19.7 54.1s-6.6 42.2-19.7 54.1zM141.7 28.4c12.8 0 25.2 2.1 37 6.1l14.3-25C177.1 3.4 159.8 0 141.7 0c-18.1 0-35.3 3.4-51.2 9.6l14.3 25c11.7-4.1 24.1-6.2 36.9-6.2zM126.5 72.6c4.9-1.1 10-1.7 15.2-1.7 5.2 0 10.3.6 15.2 1.7l14.5-25.5c-9.4-3-19.4-4.6-29.8-4.6-10.4 0-20.4 1.6-29.8 4.6l14.7 25.5z"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: "108.1",
  cy: "184.4",
  rx: "15.9",
  ry: "16"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: "175.4",
  cy: "184.4",
  rx: "15.9",
  ry: "16"
}))));